export function createDefaultLogger() {
    return console;
}
